import React from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody, TextField, IconButton, Button } from '@mui/material';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import DeleteIcon from '@mui/icons-material/Delete';

const getRowKey = (f, idx) => f.fr_id + (f.name || '') + idx;

const NewFeaturesDnDTable = ({ newFeatures, onDragEnd, onChange, onRemove, onSave }) => (
  <>
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="new-features-droppable">
        {(provided) => (
          <Table size="small" sx={{ mb: 2 }}>
            <TableHead>
              <TableRow>
                <TableCell>FR_ID</TableCell>
                <TableCell>Module</TableCell>
                <TableCell>Feature</TableCell>
                <TableCell>Task Description/Attribute</TableCell>
                <TableCell>Order</TableCell>
                <TableCell>Remove</TableCell>
              </TableRow>
            </TableHead>
            <TableBody
              ref={provided.innerRef}
              {...provided.droppableProps}
            >
              {newFeatures.map((f, idx) => (
                <Draggable key={getRowKey(f, idx)} draggableId={`new-feature-${getRowKey(f, idx)}`} index={idx}>
                  {(dragProvided, dragSnapshot) => (
                    <TableRow
                      ref={dragProvided.innerRef}
                      {...dragProvided.draggableProps}
                      style={{ ...dragProvided.draggableProps.style, background: dragSnapshot.isDragging ? '#e3f2fd' : undefined }}
                    >
                      <TableCell {...dragProvided.dragHandleProps} style={{ cursor: 'grab' }}>{f.fr_id}</TableCell>
                      <TableCell>
                        <TextField size="small" value={f.name} onChange={e => onChange(idx, 'name', e.target.value)} required />
                      </TableCell>
                      <TableCell>
                        <TextField size="small" value={f.feature} onChange={e => onChange(idx, 'feature', e.target.value)} required />
                      </TableCell>
                      <TableCell>
                        <TextField size="small" value={f.description} onChange={e => onChange(idx, 'description', e.target.value)} />
                      </TableCell>
                      <TableCell>
                        <span style={{ color: '#888' }}>Drag</span>
                      </TableCell>
                      <TableCell>
                        <IconButton color="error" onClick={() => onRemove(idx)}><DeleteIcon /></IconButton>
                      </TableCell>
                    </TableRow>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </TableBody>
          </Table>
        )}
      </Droppable>
    </DragDropContext>
    <Button variant="contained" color="primary" onClick={onSave} sx={{ mb: 2 }}>Save All</Button>
  </>
);

export default NewFeaturesDnDTable; 